export default __webpack_public_path__ + "static/media/sahinoglu6.a6d90a86.jpg";